import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconBuilding = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round">
            <StyledPath d="M16.875 3.5V19.75" color="none" />
            <StyledPath d="M3.125 3.5H16.875" color="none" />
            <StyledPath d="M3.125 19.75V3.5" color="none" />
            <StyledPath d="M16.875 19.75H3.125" color="none" />
            <StyledPath d="M16.875 3.5H3.125L4.375 1H15.625L16.875 3.5Z" color="none" />
            <StyledPath d="M0.625 19.75H19.375" color="none" />
            <StyledPath
                d="M11.875 17.875C11.875 17.3777 11.6775 16.9008 11.3258 16.5492C10.9742 16.1975 10.4973 16 10 16C9.50272 16 9.02581 16.1975 8.67417 16.5492C8.32254 16.9008 8.125 17.3777 8.125 17.875V19.75H11.875V17.875Z"
                color="none"
            />
            <StyledPath
                d="M6.25 6.3125C6.16712 6.3125 6.08763 6.27958 6.02903 6.22097C5.97042 6.16237 5.9375 6.08288 5.9375 6C5.9375 5.91712 5.97042 5.83763 6.02903 5.77903C6.08763 5.72042 6.16712 5.6875 6.25 5.6875"
                color="none"
            />
            <StyledPath
                d="M6.25 6.3125C6.33288 6.3125 6.41237 6.27958 6.47097 6.22097C6.52958 6.16237 6.5625 6.08288 6.5625 6C6.5625 5.91712 6.52958 5.83763 6.47097 5.77903C6.41237 5.72042 6.33288 5.6875 6.25 5.6875"
                color="none"
            />
            <StyledPath
                d="M10 6.3125C9.91712 6.3125 9.83763 6.27958 9.77903 6.22097C9.72042 6.16237 9.6875 6.08288 9.6875 6C9.6875 5.91712 9.72042 5.83763 9.77903 5.77903C9.83763 5.72042 9.91712 5.6875 10 5.6875"
                color="none"
            />
            <StyledPath
                d="M10 6.3125C10.0829 6.3125 10.1624 6.27958 10.221 6.22097C10.2796 6.16237 10.3125 6.08288 10.3125 6C10.3125 5.91712 10.2796 5.83763 10.221 5.77903C10.1624 5.72042 10.0829 5.6875 10 5.6875"
                color="none"
            />
            <StyledPath
                d="M13.75 6.3125C13.6671 6.3125 13.5876 6.27958 13.529 6.22097C13.4704 6.16237 13.4375 6.08288 13.4375 6C13.4375 5.91712 13.4704 5.83763 13.529 5.77903C13.5876 5.72042 13.6671 5.6875 13.75 5.6875"
                color="none"
            />
            <StyledPath
                d="M13.75 6.3125C13.8329 6.3125 13.9124 6.27958 13.971 6.22097C14.0296 6.16237 14.0625 6.08288 14.0625 6C14.0625 5.91712 14.0296 5.83763 13.971 5.77903C13.9124 5.72042 13.8329 5.6875 13.75 5.6875"
                color="none"
            />
            <StyledPath
                d="M6.25 10.0625C6.16712 10.0625 6.08763 10.0296 6.02903 9.97097C5.97042 9.91237 5.9375 9.83288 5.9375 9.75C5.9375 9.66712 5.97042 9.58763 6.02903 9.52903C6.08763 9.47042 6.16712 9.4375 6.25 9.4375"
                color="none"
            />
            <StyledPath
                d="M6.25 10.0625C6.33288 10.0625 6.41237 10.0296 6.47097 9.97097C6.52958 9.91237 6.5625 9.83288 6.5625 9.75C6.5625 9.66712 6.52958 9.58763 6.47097 9.52903C6.41237 9.47042 6.33288 9.4375 6.25 9.4375"
                color="none"
            />
            <StyledPath
                d="M10 10.0625C9.91712 10.0625 9.83763 10.0296 9.77903 9.97097C9.72042 9.91237 9.6875 9.83288 9.6875 9.75C9.6875 9.66712 9.72042 9.58763 9.77903 9.52903C9.83763 9.47042 9.91712 9.4375 10 9.4375"
                color="none"
            />
            <StyledPath
                d="M13.75 10.0625C13.6671 10.0625 13.5876 10.0296 13.529 9.97097C13.4704 9.91237 13.4375 9.83288 13.4375 9.75C13.4375 9.66712 13.4704 9.58763 13.529 9.52903C13.5876 9.47042 13.6671 9.4375 13.75 9.4375"
                color="none"
            />
            <StyledPath
                d="M13.75 10.0625C13.8329 10.0625 13.9124 10.0296 13.971 9.97097C14.0296 9.91237 14.0625 9.83288 14.0625 9.75C14.0625 9.66712 14.0296 9.58763 13.971 9.52903C13.9124 9.47042 13.8329 9.4375 13.75 9.4375"
                color="none"
            />
            <StyledPath
                d="M6.25 13.8125C6.16712 13.8125 6.08763 13.7796 6.02903 13.721C5.97042 13.6624 5.9375 13.5829 5.9375 13.5C5.9375 13.4171 5.97042 13.3376 6.02903 13.279C6.08763 13.2204 6.16712 13.1875 6.25 13.1875"
                color="none"
            />
            <StyledPath
                d="M6.25 13.8125C6.33288 13.8125 6.41237 13.7796 6.47097 13.721C6.52958 13.6624 6.5625 13.5829 6.5625 13.5C6.5625 13.4171 6.52958 13.3376 6.47097 13.279C6.41237 13.2204 6.33288 13.1875 6.25 13.1875"
                color="none"
            />
            <StyledPath
                d="M10 13.8125C9.91712 13.8125 9.83763 13.7796 9.77903 13.721C9.72042 13.6624 9.6875 13.5829 9.6875 13.5C9.6875 13.4171 9.72042 13.3376 9.77903 13.279C9.83763 13.2204 9.91712 13.1875 10 13.1875"
                color="none"
            />
            <StyledPath
                d="M10 13.8125C10.0829 13.8125 10.1624 13.7796 10.221 13.721C10.2796 13.6624 10.3125 13.5829 10.3125 13.5C10.3125 13.4171 10.2796 13.3376 10.221 13.279C10.1624 13.2204 10.0829 13.1875 10 13.1875"
                color="none"
            />
            <StyledPath
                d="M13.75 13.8125C13.6671 13.8125 13.5876 13.7796 13.529 13.721C13.4704 13.6624 13.4375 13.5829 13.4375 13.5C13.4375 13.4171 13.4704 13.3376 13.529 13.279C13.5876 13.2204 13.6671 13.1875 13.75 13.1875"
                color="none"
            />
            <StyledPath
                d="M13.75 13.8125C13.8329 13.8125 13.9124 13.7796 13.971 13.721C14.0296 13.6624 14.0625 13.5829 14.0625 13.5C14.0625 13.4171 14.0296 13.3376 13.971 13.279C13.9124 13.2204 13.8329 13.1875 13.75 13.1875"
                color="none"
            />
            <StyledPath
                d="M10 10.0625C10.0829 10.0625 10.1624 10.0296 10.221 9.97097C10.2796 9.91237 10.3125 9.83288 10.3125 9.75C10.3125 9.66712 10.2796 9.58763 10.221 9.52903C10.1624 9.47042 10.0829 9.4375 10 9.4375"
                color="none"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
